import { Module } from 'vuex'
import { ISubscriptionsState, IRootState } from '@/@types'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const subscriptions: Module<ISubscriptionsState, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default subscriptions
